import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';
import {NetworkOperator, SimCard, SimFormFactor, SimProduct, SimRange, SimRangeResponse, SuccessResponse} from '@/types';

export class SimService {
  private apiV2: ApiBaseService;

  constructor() {
    this.apiV2 = ApiV2Service;
  }

  public async getSimBatches(): Promise<SimRangeResponse[]> {
    return this.apiV2.get(`sims`);
  }

  public async createBatch(payload: any): Promise<SimRange> {
    return this.apiV2.post(`sims`, payload);
  }

  public async deleteBatch(start: string, count: number): Promise<SuccessResponse> {
    return this.apiV2.delete(`sims/${start}?count=${count}`);
  }

  public async allocateBatches(payload: any): Promise<SimRangeResponse[]> {
    return this.apiV2.put(`sims/subscriptionPlan`, payload);
  }

  public async allocateBatchesToOrder(payload: any): Promise<SimRangeResponse[]> {
    return this.apiV2.put(`sims/subscriptionOrder`, payload);
  }

  public async searchSims(searchString: string, isGateway: boolean = false): Promise<SimCard[]> {
    const organisation = store.getters.activeOrganisation[0].id;
    const queryParams = new URLSearchParams();
    let queryString = '';
    queryParams.append('searchString', searchString);
    queryParams.append('filterPaired', 'true');
    queryParams.append('isGateway', String(isGateway));
    queryString = `?${queryParams.toString()}`;
    return this.apiV2.get(`organisation/${organisation}/sims/search${queryString}`);
  }

  public async getSim(simId: number): Promise<SimCard> {
    const organisation = store.getters.activeOrganisation[0].id;
    return this.apiV2.get<SimCard>(`organisation/${organisation}/sims/${simId}`);
  }

  public async getFormFactors(): Promise<SimFormFactor[]> {
    return this.apiV2.get(`admin/network/simFormFactors`);
  }

  public async getNetworkOperators(): Promise<NetworkOperator[]> {
    return this.apiV2.get(`admin/network/operators?sims=true`);
  }

  public async getSimProducts(): Promise<SimProduct[]> {
    return this.apiV2.get(`sims/products`);
  }

  public async addSimProduct(product: SimProduct): Promise<SimProduct> {
    return this.apiV2.post(`sims/products`, product);
  }

  public async updateSimProduct(product: SimProduct): Promise<SimProduct> {
    return this.apiV2.put(`sims/products/${product.id}`, product);
  }

  public async checkSequence(iccid: any): Promise<{ success: boolean, message: string }> {
    return this.apiV2.get(`sims/checkSequence?start=${iccid.start}&end=${iccid.end}`);
  }

  public async getSimDetailsForOrganisation(
    take: number = 0,
    skip: number = 0,
    searchIccid: string | null = null,
    expiresWithin: string | null = null,
  ): Promise<{ sim_cards: SimCard[], total: number }> {
    const organisation = store.getters.activeOrganisation[0].id;
    let uri = `organisation/${organisation}/sims?take=${take}&skip=${skip}`;

    if (searchIccid) {
      uri += `&searchIccid=${encodeURIComponent(searchIccid)}`;
    }

    if (expiresWithin) {
      uri += `&expiresWithin=${expiresWithin}`;
    }

    return this.apiV2.get(uri);
  }
}

export default new SimService();
